<template>
	<div>

		<v-toolbar flat fixed>
          <v-toolbar-side-icon @click="fn_goBack"><v-icon>arrow_back</v-icon></v-toolbar-side-icon>
          <v-toolbar-title class="white--text">Join With Connection ID</v-toolbar-title>
        </v-toolbar>
		
		<div class="hasToolbar">
			<v-layout row wrap pt-3>
				<v-flex xs10 sm10 md10 form-item>
					<v-text-field v-model="connectionId" placeholder=" " label="Connection ID"></v-text-field>
				</v-flex>
				<v-flex xs2 sm2 md2 pr-2>
					<v-btn icon text @click="fn_join">Join</v-btn>
				</v-flex>
			</v-layout>
		</div>
	</div>
</template>

<script>
	export default{
		data(){
			return{
				connectionId:null,
			}
		},
		methods:{

			fn_join: function(){
				var self = this;
		        this.getData('JoinWithConnectionId', this.connectionId, 
		          {
		            onSuccess: function(response){
		              console.log(response);
		            },
		            onError: function(error){
		              console.log(error);
		              self.showToast('Something went wrong. Try again!.')
		            }
		        });
			},

			fn_goBack: function(){
                this.$router.go(-1);
            },
		},
		mounted: function(){
            window.js_globals.fn_onBackPress = this.fn_goBack;
        }
	}
</script>


// WEBPACK FOOTER //
// src/components/settings/join.vue